export const GET_CHECKLIST_REQUEST = 'checkListReducer/GET_CHECKLIST_REQUEST';
export const GET_CHECKLIST_SUCCESS = 'checkListReducer/GET_CHECKLIST_SUCCESS';
export const GET_CHECKLIST_FAILED = 'checkListReducer/GET_CHECKLIST_FAILED';
